import React, {Component} from 'react';
import Styles from './style.css';
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {dataRegister} from "../../services/dataRegister";
import {langRegister} from "../../services/langRegister";
import {userRegister} from "../../services/userRegister";
import {tokenRegister} from "../../services/tokenRegister";
import Moment from 'react-moment';
import {salesChannelRegister} from "../../services/salesChannelRegister";
import LanguageButton from "../language-button/component";
import {agentRegister} from "../../services/agentRegister";
import ReactGA from "react-ga";
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";

class userLeads extends Component {

    constructor(props) {
        super(props);
        this.state = {
            leads: [],
            isLoading: true,
            search: "",
            per_page: 200,
            page: 0,
            isLoadingButton: false,
            show_loadmore: true,
            edit_dropdown: true,
            filters: [],
            selected_filter: "",
            selected_type: false,
        };
    };

    componentWillMount() {
        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/user/leads');
            ReactGA4.send({ hitType: "pageview", page: "/user/leads" });
        }
        //FACEBOOK PIXEL
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactPixel.pageView();
        }
        this.setState({
            filters: [this._renderText("item_9"), this._renderText("item_81"), this._renderText("item_123"), this._renderText("item_80"), this._renderText("item_147")],
            selected_filter: this._renderText("item_9")
        });
        this._updateItems();
        //this._updateUser();
    }

    _updateItems(){
        dataRegister.getLeads(salesChannelRegister.get('market'), langRegister.lang(), this.state.page, this.state.per_page).then((response) => {
            if(response.constructor === Array){
                this.setState({leads: response, isLoading: false, error: false, page: this.state.page + 1}, () => {
                    if(response.length < 200){
                        this.setState({show_loadmore: false});
                    }
                });
            }else{
                this.setState({isLoading: false});
            }
        }, (error) => {
            if(error.status === 401){
                userRegister.remove();
                tokenRegister.remove();
                agentRegister.remove();
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/login");
            }else{
                this.setState({isLoading: false, error: true});
            }
        });
    }

    _updateUser() {
        let user = userRegister.get();
        if (user) {
            this.setState({
                user: user,
                reseller: user.reseller,
                inhouse: user.inhouse,
                reseller_type: user.reseller_type
            });
            if (user.socialData) {
                this.setState({
                    settlements: user.socialData.settlements ? user.socialData.settlements : false,
                    branding: user.socialData.branding ? user.socialData.branding : false,
                    crm: user.socialData.crm ? user.socialData.crm : false,
                    feeds: user.socialData.feeds ? user.socialData.feeds : false,
                    wa_override: user.socialData.wa_override ? user.socialData.wa_override : false,
                    double_qualify: user.socialData.double_qualify ? user.socialData.double_qualify : false
                });
            }
        }
    }

    _loadMore(){
        this.setState({isLoadingButton: true}, () => {
            dataRegister.getLeads(salesChannelRegister.get('market'), langRegister.lang(), this.state.page, this.state.per_page).then((response) => {
                if(response.constructor === Array){
                    if(response.length > 0){
                        let leads = this.state.leads.concat(response);
                        this.setState({leads: leads, isLoadingButton: false, error: false, page: this.state.page + 1}, () => {
                            if(response.length < 200){
                                this.setState({show_loadmore: false});
                            }
                        });
                    }else{
                        this.setState({isLoadingButton: false, error: false, show_loadmore: false});
                    }
                }else{
                    this.setState({isLoadingButton: false});
                }
            }, (error) => {
                if(error.status === 401){
                    userRegister.remove();
                    agentRegister.remove();
                    tokenRegister.remove();
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/login");
                }else{
                    this.setState({isLoading: false, error: true});
                }
            });
        });
    }

    _signOut() {
        userRegister.remove();
        tokenRegister.remove();
        agentRegister.remove();
        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/login");
    }

    _renderIcon(key) {
        if(key === 'fb' || key === 'facebook' || key === 'bing' || key === 'instagram' || key === 'google' || key === 'pb' || key === 'yl' || key === 'bb' || key === 'tiktok' || key === 'snapchat' || key === 'proptree'){
            if(salesChannelRegister.get("name") === "yieldlock"){
                let color = "#00273A";
                if(key === "facebook"){
                    key = "fb";
                }
                let size = "cardSubtitleInnerIconsItem" + key;
                return (
                    <div style={{backgroundColor: color, marginLeft: "10px"}} className={cx(Styles.cardSubtitleInnerIconsItem)}>
                        <img className={Styles[size]} src={require("../../assets/images/" + key + "_logo_icon.svg")}/>
                    </div>
                )
            }else if(salesChannelRegister.get("name") === "propertybooster"){
                let color = "#000000";
                if(key === "facebook"){
                    key = "fb";
                }
                let size = "cardSubtitleInnerIconsItem" + key;
                return (
                    <div style={{backgroundColor: color, marginLeft: "10px"}} className={cx(Styles.cardSubtitleInnerIconsItem)}>
                        <img className={Styles[size]} src={require("../../assets/images/" + key + "_logo_icon.svg")}/>
                    </div>
                )
            }else if(salesChannelRegister.get("name") === "boostabostad"){
                let color = "#000000";
                if(key === "facebook"){
                    key = "fb";
                }
                let size = "cardSubtitleInnerIconsItem" + key;
                return (
                    <div style={{backgroundColor: color, marginLeft: "10px"}} className={cx(Styles.cardSubtitleInnerIconsItem)}>
                        <img className={Styles[size]} src={require("../../assets/images/" + key + "_logo_icon.svg")}/>
                    </div>
                )
            }else{
                let color = "cardSubtitleInnerIconsItemColor" + key;
                let size = "cardSubtitleInnerIconsItem" + key;
                return (
                    <div className={
                        cx(Styles.cardSubtitleInnerIconsItem,
                            {
                                [Styles[color]]: this.state.open
                            })
                    }>
                        <img className={Styles[size]} src={require("../../assets/images/" + key + "_logo_icon.svg")}/>
                    </div>
                )
            }
        }
    }

    _getFilterType(filter) {
        let type = "";
        try {
            if (filter === this._renderText("item_80")) {
                type = "1";
                this.setState({selected_type: true});
            } else if (filter === this._renderText("item_81")) {
                type = "2";
                this.setState({selected_type: true});
            } else if (filter === this._renderText("item_123")) {
                type = "4";
                this.setState({selected_type: true});
            } else if (filter === this._renderText("item_147")) {
                type = "5";
                this.setState({selected_type: true});
            } else {
                this.setState({selected_type: false});
            }
            //console.log(type);
            return type;
        } catch (e) {
        }
    }

    _renderText(item) {
        return langRegister.get("user-leads", item);
    }

    render() {
        return (
            <div>
                <div className={Styles.contentHeader}>
                    <div className={Styles.contentHeaderSearch}>
                        {
                            !this.state.selected_type &&
                        <input value={this.state.selected_type ? "" : this.state.search} onChange={(event) => this.setState({search: event.target.value})} placeholder={this._renderText("item_3")} className={Styles.contentHeaderSearchInput}/>
                        }
                        {
                            !this.state.selected_type && salesChannelRegister.get('name') === "propertybooster" &&
                            <img className={Styles.contentHeaderSearchInputIcon} src={require("../../assets/images/search_icon_2.png")}/>
                        }
                        {
                            !this.state.selected_type && salesChannelRegister.get('name') === "yieldlock" &&
                            <img className={Styles.contentHeaderSearchInputIcon} src={require("../../assets/images/search_icon_2_yl.png")}/>
                        }
                        {
                            !this.state.selected_type && salesChannelRegister.get('name') === "boostabostad" &&
                            <img className={Styles.contentHeaderSearchInputIcon} src={require("../../assets/images/search_icon_boostabostad.png")}/>
                        }
                    </div>

                    <LanguageButton props={this.props}/>
                    <div onClick={() => this._signOut()} className={Styles.contentHeaderButton}>
                        {this._renderText("item_1")}
                    </div>
                </div>
                <div className={Styles.container}>
                    <div className={Styles.containerInner}>
                        {
                            !this.state.isLoading && this.state.leads.length > 0 && !this.state.error &&
                        <div className={
                            cx(Styles.dropdown,
                                {
                                    [Styles.dropdownDisabled]: !this.state.edit_dropdown,
                                })
                        }>
                            <select disabled={!this.state.edit_dropdown} className={
                                cx(Styles.dropdownSelection,
                                    {
                                        [Styles.dropdownSelectionDisabled]: !this.state.edit_dropdown,
                                    })} value={this.state.selected_filter} onChange={(event) => this.setState({selected_filter: event.target.value, search: this._getFilterType(event.target.value)})}>
                                {
                                    this.state.filters.map((item) => {
                                        return(
                                            <option value={item}>{item}</option>
                                        )
                                    })
                                }
                            </select>
                            <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.dropdownText}>
                                {this.state.selected_filter}
                            </div>
                            {
                                salesChannelRegister.get('name') !== "yieldlock" &&
                                <img className={Styles.dropdownArrow} src={require("../../assets/images/arrow-down.svg")}/>
                            }
                            {
                                salesChannelRegister.get('name') === "yieldlock" &&
                                <img className={Styles.dropdownArrow} src={require("../../assets/images/arrow-down-yl.svg")}/>
                            }
                        </div>
                        }
                        {
                            !this.state.isLoading && this.state.leads.length > 0 && !this.state.error &&
                            this.state.leads.filter((item) => {return this.state.selected_type ? item.type === this.state.search : (item.name && item.name.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1) || (item.ref && item.ref.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1) || (item.email && item.email.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1) || (item.phone && item.phone.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1)}).sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp)).map((item, index) => {
                                return(
                                    <div className={Styles.summaryContainerItem}>
                                        <div style={{flexDirection:"row", display: "flex"}} className={Styles.summaryContainerItemTitle}>
                                            <Moment format="YYYY.MM.DD">
                                                {item.timestamp}
                                            </Moment>
                                            {item.from_channel && item.from_channel !== "" && this._renderIcon(item.from_channel)}
                                            {
                                                (salesChannelRegister.get("name") === "propertybooster" && (!item.from_channel || item.from_channel === "")) &&
                                                <div style={{backgroundColor: "#33B8CF", marginLeft: "10px"}} className={cx(Styles.cardSubtitleInnerIconsItem)}>
                                                    <img className={Styles.cardSubtitleInnerIconsItemInternal} src={require("../../assets/images/pb_logo_icon.svg")}/>
                                                </div>
                                            }
                                            {
                                                (salesChannelRegister.get("name") === "boostabostad" && (!item.from_channel || item.from_channel === "")) &&
                                                <div style={{backgroundColor: "#7ECF5B", marginLeft: "10px"}} className={cx(Styles.cardSubtitleInnerIconsItem)}>
                                                    <img className={Styles.cardSubtitleInnerIconsItemInternal} src={require("../../assets/images/bb_logo_icon.svg")}/>
                                                </div>
                                            }
                                            {
                                                (salesChannelRegister.get("name") === "yieldlock" && (!item.from_channel || item.from_channel === "")) &&
                                                <div style={{backgroundColor: "#00273A", marginLeft: "10px"}} className={cx(Styles.cardSubtitleInnerIconsItem)}>
                                                    <img className={Styles.cardSubtitleInnerIconsItemInternal} src={require("../../assets/images/yl_logo_icon.svg")}/>
                                                </div>
                                            }
                                        </div>
                                        <div className={Styles.summaryContainerItemSummaryLeads}>
                                            {
                                                item.picture &&
                                                <div style={{marginRight: "15px"}}>
                                                    {
                                                        <div className={Styles.contentInnerItemHeaderImage} style={{position: "relative"}}>
                                                            <div className={Styles.contentInnerItemHeaderImageItem} style={{backgroundImage: "url(" + item.picture + ")", position: "absolute"}}/>
                                                            {
                                                                item.event !== "6" &&
                                                                <img className={Styles.contentInnerItemHeaderImageItem} src={require("../../assets/images/user_image_placeholder.jpg")}/>
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            }
                                            {
                                                item.ref &&
                                                <div style={{marginRight: "15px"}}>
                                                            <span style={{marginRight: "5px"}} className={Styles.summaryContainerItemSummaryBold}>
                                                                {this._renderText("item_10")}
                                                            </span>
                                                    <span>
                                                                {item.ref}
                                                            </span>
                                                </div>
                                            }
                                            {
                                                item.type &&
                                                <div style={{marginRight: "15px"}}>
                                                            <span style={{marginRight: "5px"}} className={Styles.summaryContainerItemSummaryBold}>
                                                                {this._renderText("item_79")}
                                                            </span>
                                                    {
                                                        item.type === "1" &&
                                                        <span>
                                                                    {this._renderText("item_80")}
                                                                </span>
                                                    }
                                                    {
                                                        item.type === "2" &&
                                                        <span>
                                                                    {this._renderText("item_81")}
                                                                </span>
                                                    }
                                                    {
                                                        item.type === "3" &&
                                                        <span>
                                                                {this._renderText("item_93")}
                                                                </span>
                                                    }
                                                    {
                                                        item.type === "4" &&
                                                        <span>
                                                                {this._renderText("item_123")}
                                                                </span>
                                                    }
                                                    {
                                                        item.type === "5" &&
                                                        <span>
                                                                {this._renderText("item_147")}
                                                                </span>
                                                    }
                                                </div>
                                            }
                                            {
                                                item.event &&
                                                <div style={{marginRight: "15px"}}>
                                                            <span style={{marginRight: "5px"}} className={Styles.summaryContainerItemSummaryBold}>
                                                                {this._renderText("item_78")}
                                                            </span>
                                                    {
                                                        item.event === "1" &&
                                                        <span>
                                                                {this._renderText("item_82")}
                                                            </span>
                                                    }
                                                    {
                                                        item.event === "2" &&
                                                        <span>
                                                                {this._renderText("item_83")}
                                                            </span>
                                                    }
                                                    {
                                                        item.event === "3" &&
                                                        <span>
                                                                {this._renderText("item_84")}
                                                            </span>
                                                    }
                                                    {
                                                        item.event === "4" &&
                                                        <span>
                                                                {this._renderText("item_85")}
                                                            </span>
                                                    }
                                                    {
                                                        item.event === "5" &&
                                                        <span>
                                                                {this._renderText("item_86")}
                                                            </span>
                                                    }
                                                    {
                                                        item.event === "6" &&
                                                        <span>
                                                                {this._renderText("item_89")}
                                                            </span>
                                                    }
                                                    {
                                                        item.event === "7" &&
                                                        <span>
                                                                {this._renderText("item_90")}
                                                            </span>
                                                    }
                                                    {
                                                        item.event === "8" &&
                                                        <span>
                                                                {this._renderText("item_91")}
                                                            </span>
                                                    }
                                                    {
                                                        item.event === "9" &&
                                                        <span>
                                                                {this._renderText("item_92")}
                                                            </span>
                                                    }
                                                    {
                                                        item.event === "10" &&
                                                        <span>
                                                                {this._renderText("item_96")}
                                                            </span>
                                                    }
                                                    {
                                                        item.event === "11" &&
                                                        <span>
                                                                {this._renderText("item_97")}
                                                            </span>
                                                    }
                                                    {
                                                        item.event === "12" &&
                                                        <span>
                                                                {this._renderText("item_98")}
                                                            </span>
                                                    }
                                                    {
                                                        item.event === "13" &&
                                                        <span>
                                                                {this._renderText("item_99")}
                                                            </span>
                                                    }
                                                    {
                                                        item.event === "14" &&
                                                        <span>
                                                                {this._renderText("item_100")}
                                                            </span>
                                                    }
                                                    {
                                                        item.event === "15" &&
                                                        <span>
                                                                {this._renderText("item_105")}
                                                            </span>
                                                    }
                                                    {
                                                        item.event === "16" &&
                                                        <span>
                                                                {this._renderText("item_106")}
                                                            </span>
                                                    }
                                                    {
                                                        item.event === "18" &&
                                                        <span>
                                                                {this._renderText("item_124")}
                                                            </span>
                                                    }
                                                    {
                                                        item.event === "19" &&
                                                        <span>
                                                                {this._renderText("item_127")}
                                                            </span>
                                                    }
                                                    {
                                                        item.event === "20" &&
                                                        <span>
                                                                {this._renderText("item_129")}
                                                            </span>
                                                    }
                                                    {
                                                        item.event === "21" &&
                                                        <span>
                                                                {this._renderText("item_130")}
                                                            </span>
                                                    }
                                                    {
                                                        item.event === "22" &&
                                                        <span>
                                                                {this._renderText("item_131")}
                                                            </span>
                                                    }
                                                    {
                                                        item.event === "23" &&
                                                        <span>
                                                                {this._renderText("item_140")}
                                                            </span>
                                                    }
                                                    {
                                                        item.event === "24" &&
                                                        <span>
                                                                {this._renderText("item_141")}
                                                            </span>
                                                    }
                                                    {
                                                        item.event === "25" &&
                                                        <span>
                                                                {this._renderText("item_142")}
                                                            </span>
                                                    }
                                                    {
                                                        item.event === "26" &&
                                                        <span>
                                                                {this._renderText("item_143")}
                                                            </span>
                                                    }
                                                    {
                                                        item.event === "27" &&
                                                        <span>
                                                                {this._renderText("item_144")}
                                                            </span>
                                                    }
                                                    {
                                                        item.event === "28" &&
                                                        <span>
                                                                {this._renderText("item_145")}
                                                            </span>
                                                    }
                                                    {
                                                        item.event === "29" &&
                                                        <span>
                                                                {this._renderText("item_146")}
                                                            </span>
                                                    }
                                                </div>
                                            }
                                            {
                                                item.company &&
                                                <div style={{marginRight: "15px"}}>
                                                            <span style={{marginRight: "5px"}} className={Styles.summaryContainerItemSummaryBold}>
                                                                {this._renderText("item_87")}
                                                            </span>
                                                    <span>
                                                                {item.company}
                                                            </span>
                                                </div>
                                            }
                                            {
                                                item.website &&
                                                <div className={Styles.summaryContainerItemSummaryLinks} style={{marginRight: "15px"}}>
                                                            <span style={{marginRight: "5px"}} className={Styles.summaryContainerItemSummaryBold}>
                                                                {this._renderText("item_88")}
                                                            </span>
                                                    <span>
                                                                <a className={Styles.summaryContainerItemSummaryLinks} href={item.website.indexOf("https://") ? "https://" + item.website : item.website} target="_blank">
                                                                {item.website.toLowerCase()}
                                                                </a>
                                                            </span>
                                                </div>
                                            }
                                            {
                                                item.name &&
                                                <div style={{marginRight: "15px"}}>
                                                            <span style={{marginRight: "5px"}} className={Styles.summaryContainerItemSummaryBold}>
                                                                {this._renderText("item_74")}
                                                            </span>
                                                    <span>
                                                                {item.name}
                                                            </span>
                                                </div>
                                            }
                                            {
                                                item.email &&
                                                <div className={Styles.summaryContainerItemSummaryLinks} style={{marginRight: "15px"}}>
                                                            <span style={{marginRight: "5px"}} className={Styles.summaryContainerItemSummaryBold}>
                                                            {this._renderText("item_75")}
                                                            </span>
                                                    <a className={Styles.summaryContainerItemSummaryLinks} href={"mailto:" + item.email + "?Subject=" + this._renderText("item_77")} target="_top">
                                                        {item.email.toLowerCase()}
                                                    </a>
                                                </div>
                                            }
                                            {
                                                item.phone &&
                                                <div style={{marginRight: "15px"}}>
                                                             <span style={{marginRight: "5px"}} className={Styles.summaryContainerItemSummaryBold}>
                                                            {this._renderText("item_76")}
                                                        </span>
                                                    <a className={Styles.summaryContainerItemSummaryLinks} href={"tel:" + item.phone}>{item.phone}</a>
                                                </div>
                                            }
                                            {
                                                item.info &&
                                                <div style={{marginRight: "15px"}}>
                                                            <span style={{marginRight: "5px"}} className={Styles.summaryContainerItemSummaryBold}>
                                                                {this._renderText("item_122")}
                                                            </span>
                                                    <span>
                                                                {item.info}
                                                            </span>
                                                </div>
                                            }
                                            {
                                                item.other &&
                                                <div style={{marginRight: "15px"}}>
                                                            <span style={{marginRight: "5px"}} className={Styles.summaryContainerItemSummaryBold}>
                                                                {this._renderText("item_128")}
                                                            </span>
                                                    <span>
                                                                {item.other}
                                                            </span>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                )
                            })
                        }
                        {
                            !this.state.isLoading && !this.state.error && this.state.show_loadmore &&
                            <div className={Styles.loadMoreButtonContainer}>
                                <div className={Styles.loadMoreButton} onClick={() => {this._loadMore()}}>
                                    {
                                        this.state.isLoadingButton &&
                                        <BeatLoader size={10} color={'#ffffff'} loading={true}/>
                                    }
                                    {
                                        !this.state.isLoadingButton &&
                                        <img className={Styles.loadMoreButtonIcon} src={require("../../assets/images/plus_sign_white_small.png")}/>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                    {
                        !this.state.isLoading && this.state.leads.length < 1 && !this.state.error &&
                        <div className={Styles.noResult}>
                            {this._renderText("item_7")}
                        </div>
                    }
                    {
                        !this.state.isLoading && this.state.error &&
                        <div className={Styles.noResult}>
                            {this._renderText("item_8")}
                        </div>
                    }
                    {
                        this.state.isLoading &&
                        <div className={Styles.loader}>
                            <BeatLoader size={30} color={'var(--first-color)'} loading={true}/>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default userLeads;


// WEBPACK FOOTER //
// ./src/components/user-leads/component.js